var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.featuredEntry)?_c('div',{staticClass:"b-featured-entry"},[_c('featured-entry',{attrs:{"entry":_vm.featuredEntry,"card-type":_vm.cardType,"img-shape":_vm.data.assetShape,"display-before-asset":false,"model":_vm.model}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }